import React from "react";
import "./Aicard.css";
import Pdf from "../../assets/svg";

const Aicard = (props) => {
  return (
    <div className="aicard">
      <div className="aicard__info">
        {" "}
        <p className="aicard__count">[{props.count}]</p>
        <p className="aicard__link">{props.link}</p>
      </div>
      <div className="aicard__info">
        <Pdf /> <p className="aicard__pdf">{props.pdfFileName}</p>
      </div>
      <div className="aicard__info">
        <p className="aicard__text">{props.text}</p>
      </div>
    </div>
  );
};

export default Aicard;
